<template>
  <base-stripe-table
    :headers="headers"
    :fetch-action="'listPayouts'"
    :fetch-query="{ expand: [ 'data.destination'] }"
    :items-getter="'getPayouts'"
    :pagination-getter="'getPayoutPagination'"
  >
    <template v-slot:body="{ items }">
      <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
        >
          <td
            v-money="{
              amount: item.amount,
              currency: item.currency
            }"
          >
          </td>
          <td>
            <payout-status-chip
              :payout="item"
            />
          </td>
          <td>
            {{ _get(item, 'destination.bank_name', '') }} **** {{ _get(item, 'destination.last4', '') }}
          </td>
          <td v-date="item.created"/>
        </tr>
      </tbody>
    </template>
  </base-stripe-table>
</template>
<script>
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import PayoutStatusChip from "./PayoutStatusChip"
import { get } from 'lodash'

export default {
  components: {
    PayoutStatusChip,
    BaseStripeTable
  },
  methods: {
    _get: (val, path, def) => get(val, path, def)
  },
  data() {
    return {
      headers: [
        {
          text: 'Amount',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Status',
          sortable: false,
        },
        {
          text: 'External Account',
          sortable: false
        },
        {
          text: 'Date',
          sortable: false
        },
      ]
    }
  }
}
</script>
